module.exports = __webpack_public_path__ + "static/media/Upload Blue.eff7d874.svg";